<template>
	<div id="app">

		<div class="card border-primary" style="margin-bottom:20px;">
			<div class="card-header">
				<h5 style="margin-bottom:0px;">BetRadar Odds API</h5>
			</div>
			<div class="card-body">
				<div class="form-row">
					<div class="col">
						<div class="form-group">
							<label>Odds Format</label>
							<select @change="selectOddsFormat" class="form-control">
								<option value="eu">Decimal</option>
								<option value="uk">Fractional</option>
								<option value="us">American</option>
							</select>
						</div>
					</div>
					<div class="col">
						<div class="form-group">
							<label>Country</label>
							<select @change="selectCountry" class="form-control">
								<option value="US">US</option>
								<option value="ROW">ROW</option>
							</select>
						</div>
					</div>
					<div class="col">
						<div class="form-group">
							<label>Odds type</label>
							<select @change="selectOddsType" class="form-control">
								<option value="odds">Odds</option>
								<option value="outright_odds">Outright Odds</option>
								<option value="consensus_lines">Consensus Lines</option>
							</select>
						</div>
					</div>
					<div class="col">
						<div class="form-group">
							<label>Sport</label>
							<select @change="selectSport" class="form-control">
								<option value="">-- Select --</option>
								<option v-for="sport in sports" :value="sport.id">{{ sport.name }}</option>
							</select>
						</div>
					</div>
					<div class="col" v-if="oddsType == 'outright_odds'">
						<div class="form-group">
							<label>Category</label>
							<select @change="selectCategory" class="form-control">
								<option value="">-- Select --</option>
								<option v-for="category in filteredCategories" :value="category.id">{{ category.name }}</option>
							</select>
						</div>
					</div>
					<div class="col" v-if="oddsType == 'odds' || oddsType == 'consensus_lines'">
						<div class="form-group">
							<label>Tournament</label>
							<select @change="selectTournament" class="form-control">
								<option value="">-- Select --</option>
								<option v-for="tournament in filteredTournaments" :value="tournament.id">
									{{ tournament.name }} <template v-if="tournament.category">- {{ tournament.category.name }}</template>
								</option>
							</select>
						</div>
					</div>
				</div>
				
				<div v-if="tournamentId != '' || categoryId != ''">
					<p>This is the data coming from BetRadar before it is stored in the Matrix database.</p>
					<table class="table" style="text-align:left;">
						<tr>
							<td>Endpoint</td>
							<td>
								<a :href="betradarEndpoint" target="_blank">{{ betradarEndpoint }}</a>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>

		<OddsTable v-if="oddsType == 'odds'"
			:sport_events="sport_events"
		></OddsTable>

		<OutrightsTable v-if="oddsType == 'outright_odds'"
			:outrights="outrights"
		></OutrightsTable>

		<ConsensusLinesTable v-if="oddsType == 'consensus_lines'"
			:sport_events="sport_events"
		></ConsensusLinesTable>
	</div>
</template>

<script>
import OddsTable from './components/OddsTable.vue'
import ConsensusLinesTable from './components/ConsensusLinesTable.vue'
import OutrightsTable from './components/OutrightsTable.vue'
import axios from 'axios'

const API_KEY_US = '3fpzs5s3h8h6yq6e7my8rhg8';
const API_KEY_ROW = 'ft88gt8ue23d8utg5wvb73ar';

export default {
	name: 'app',
  	components: {
		OddsTable,
		OutrightsTable,
		ConsensusLinesTable
	},
	data: function() {
		return {
			tournaments: [],
			sport_events: [],
			sports: [],
			categories: [],
			sportId: '',
			categoryId: '',
			country: 'US',
			tournamentId: '',
			oddsType: 'odds',
			outrights: [],
			endpoint: '',
			apiKey: API_KEY_US,
			odds_format: 'eu',
		}
	},  
	created: function() {

		this.initialiseDropDowns();
	
	},
	methods: {
		selectTournament: function(event) {

			this.tournamentId = event.target.value;
			this.showOddsTypeTable();			
		},

		selectOddsType: function(event) {

			this.oddsType = event.target.value;
		
		},

		selectCategory: function(event) {

			this.categoryId = event.target.value;
			this.showOddsTypeTable();
		},

		showOddsTypeTable() {
			
			if(this.oddsType == 'odds' || this.oddsType == 'consensus_lines') {
				this.showTournamentEvents();
			}
			else if (this.oddsType == 'outright_odds') {
				this.showOutrights();
			}
		},

		initialiseDropDowns() {

			this.tournamentId = '';
			this.categoryId = '';
			this.sportId = '';
			this.sports = [];
			this.tournaments = [];
			this.categories = [];
			this.sport_events = [];
			this.outrights = [];

			// get full list of sports
			axios.get(`https://kaxmatrix.com/oddsapi/oddscomparison-${this.country.toLowerCase()}p1/en/${this.odds_format}/sports.json?api_key=${this.apiKey}`, 
				{ crossdomain: true })
			.then((response) => {
				
				let sports = response.data.sports

				sports.sort(this.sortAlphabetically);

				this.sports = sports;
			
			}, (error) => {
				console.log(error)
			});

			// get full list of tournaments
			axios.get(`https://kaxmatrix.com/oddsapi/oddscomparison-${this.country.toLowerCase()}p1/en/${this.odds_format}/tournaments.json?api_key=${this.apiKey}`, 
				{ crossdomain: true })
			.then((response) => {
				
				let tournaments = response.data.tournaments

				tournaments.sort(this.sortAlphabetically);

				this.tournaments = tournaments;
			
			}, (error) => {
				console.log(error)
			});

			// get full list of categories
			axios.get(`https://kaxmatrix.com/oddsapi/oddscomparison-${this.country.toLowerCase()}p1/en/${this.odds_format}/categories.json?api_key=${this.apiKey}`, 
				{ crossdomain: true })
			.then((response) => {
				
				let categories = response.data.categories

				categories.sort(this.sortAlphabetically);

				this.categories = categories;
			
			}, (error) => {
				console.log(error)
			});

		},

		showOutrights() {

			let categoryId = this.categoryId;
			
			if(categoryId == '') return;

			let endpoint = '';

			endpoint = `https://kaxmatrix.com/oddsapi/oddscomparison-${this.country.toLowerCase()}p1/en/${this.odds_format}/categories/${categoryId}/outrights.json?api_key=${this.apiKey}`;
			

			this.endpoint = endpoint;

			axios.get(endpoint, 
				{ crossdomain: true })
			.then((response) => {
				
				console.log(response.data.outrights);

				this.outrights = response.data.outrights;
				
			}, (error) => {
				console.log(error)
			});
		},

		showTournamentEvents() {

			let tournamentId = this.tournamentId;

			if(tournamentId == '') return;

			let endpoint = '';

			endpoint = `https://kaxmatrix.com/oddsapi/oddscomparison-${this.country.toLowerCase()}p1/en/${this.odds_format}/tournaments/${tournamentId}/schedule.json?api_key=${this.apiKey}`;

			this.endpoint = endpoint;

			axios.get(endpoint, 
				{ crossdomain: true })
			.then((response) => {
				
				console.log(response);
				this.sport_events = response.data.sport_events;
				

			}, (error) => {
				console.log(error)
			});
		},

		selectSport: function(event) {

			this.sportId = event.target.value;
		},

		selectOddsFormat: function(event) {

			this.odds_format = event.target.value;

			this.initialiseDropDowns();
		},

		selectCountry: function(event) {
			
			this.country = event.target.value;

			if(this.country == 'US') { this.apiKey = API_KEY_US }
			else if(this.country == 'ROW') { this.apiKey = API_KEY_ROW }

			this.initialiseDropDowns();
			//this.showOddsTypeTable();
		},

		sortAlphabetically: function(a, b) {
			var nameA = a.name.toUpperCase(); // ignore upper and lowercase
			var nameB = b.name.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		}
	},
	computed: {
		filteredTournaments() {

			if (this.sportId == '') {
				return this.tournaments;
			}

			return this.tournaments.filter(a => a.sport.id == this.sportId);
		},

		filteredCategories() {
			if (this.sportId == '') {
				return this.categories;
			}

			return this.categories.filter(a => a.sport_id == this.sportId);
		},

		betradarEndpoint() {
			return this.endpoint.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
		}
	}  
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
  font-size: 12px;
}

table {
	width: 100%;
}

</style>

